import { z } from 'zod';
/**
 * Marketplace catalog taxonomy. The `/admin/integrations` directory
 * groups connectors into eight buckets the operator can filter on; each
 * vendor entry in the static catalog (`CONNECTED_CATALOG`,
 * `SUGGESTED`, `BROWSE_ALL` in `apps/web/src/pages/admin-integrations.tsx`)
 * tags itself with one. The chip filter keys in `FILTER_CATEGORY` map
 * `all → null` (pass-through) and each chip slug → its `CatalogCategory`.
 *
 * Add a new bucket here, then add the matching chip key + i18n entry in
 * `apps/web/src/pages/admin-integrations.tsx`. The closed set lives in
 * one place so every catalog tag and every chip-key map stay in lockstep.
 */
export const CATALOG_CATEGORIES = [
    'Identity',
    'CRM',
    'Communications',
    'Finance',
    'Code',
    'HR',
    'Knowledge',
    'Product',
];
export const CatalogCategory = z.enum(CATALOG_CATEGORIES);
/**
 * 3-tone status for a connector sync run row on
 * `/admin/integrations/google-workspace/health`. The connector adapter
 * (TODO: issue #114) will emit one of these per run; until then the page
 * renders placeholder rows tagged `ok`. Distinct from
 * `ConnectorStatus` (the connection-lifecycle enum) — this is a single
 * sync attempt's outcome, not the parent connector's overall state.
 */
export const SYNC_RUN_STATUSES = ['ok', 'warn', 'error'];
export const SyncRunStatus = z.enum(SYNC_RUN_STATUSES);
/**
 * 4-tone derived status for a row in the cross-integration audit log
 * (`/admin/integrations/audit`). Derived from the action suffix per
 * `deriveStatus()` in `admin-integrations-audit.tsx` — the underlying
 * `audit/*` collection does NOT carry a status field. Distinct from
 * `SyncRunStatus` (3-tone, connector-specific) because audit rows
 * include `skip` (proactively suppressed) and use `err` not `error`
 * to keep the column-width budget tight.
 */
export const AUDIT_ROW_STATUSES = ['ok', 'warn', 'err', 'skip'];
export const AuditRowStatus = z.enum(AUDIT_ROW_STATUSES);
